import BaseService from './BaseService'

class ScoringService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  getProfiles = async (locationId: string) => await this.requests.get(`/profile?locationId=${locationId}`)
}

const instance = new ScoringService(BaseService.servicesConfig.Scoring)

export default instance